import * as utils from '../../utils';
import { colormaps } from '../../../public/js-colormaps';

/*import interfaces*/
import { Aeroval } from '../../types/global';
declare var aeroval: Aeroval;

export function discreteColorscale(value: number, scale: number[], parameterDir: string, statisticDir: string, colorMapType: 'linear' | 'logarithmic' = 'linear'): string {
	//this export function works with discrete colorscale
	const nColors = scale.length - 1;

	let iLevel = 0;
	for (let i = 0; i < scale.length - 1; i++) {
		if (value >= scale[i] && value < scale[i + 1]) {
			iLevel = i;
			break;
		}
	}
	//if value greater than upper limit
	if (value >= scale[scale.length - 1]) iLevel = scale.length - 1;
	//if value lower than lower limit
	if (value <= scale[0]) iLevel = 0;
	// Guard against division by zero when the scale has only 2 entries (nColors === 1).
	let normalizedValue = nColors > 1 ? iLevel / (nColors - 1) : iLevel > 0 ? 1 : 0;
	normalizedValue = Math.min(normalizedValue, 1)

	if (colorMapType === 'logarithmic') {
		const steepness = 10
		normalizedValue = Math.log(1 + steepness * normalizedValue) / Math.log(1 + steepness)
	}

	const colorMap = getColorMap(parameterDir, statisticDir);
	const color = utils.interpolateLinearly(normalizedValue, colorMap);
	//returns hex color
	return utils.rgbToHex(Math.round(color[0] * 255), Math.round(color[1] * 255), Math.round(color[2] * 255));
}

export function continuousColorscale(value: number, scale: number[], statisticDir: string): string {
	const nCol = scale.length;
	let iLevel = 0;

	for (let i: number = 0; i < scale.length; i++) {
		if (value > scale[i] && value <= scale[i + 1]) {
			iLevel = i;
			break;
		}
	}
	//if value greater than upper limit
	if (value >= scale[scale.length - 1]) {
		iLevel = scale.length - 2;
	}
	//if value lower than lower limit
	if (value <= scale[0]) {
		iLevel = 0;
	}
	var val = (1 + iLevel) / (nCol - 1);

	// colorMap
	const colorMap = getColorMap(aeroval.parameterDir, statisticDir);
	const color = utils.interpolateLinearly(val, colorMap);

	//returns hex color
	return utils.rgbToHex(Math.round(color[0] * 255), Math.round(color[1] * 255), Math.round(color[2] * 255));
}

export function reverseColorscale(colorscale: Aeroval['colormap']): Aeroval['colormap'] {
	const reversedColorscale: Aeroval['colormap'] = [];
	for (let i = colorscale.length - 1; i >= 0; i--) {
		let rgb = colorscale[i][1];
		let x = 1 - i / colorscale.length;
		reversedColorscale.push([x, [rgb[0], rgb[1], rgb[2]]]);
	}
	return reversedColorscale;
}

function getColorMap(parameterDir: string, statisticDir: string): Aeroval['colormap'] {
	let colorMapName = window.location.pathname.includes('/maps')
		? aeroval.ranges[parameterDir].colmap
		: aeroval.statistics[statisticDir].colmap;
	let reverseColorMap = false
	if (colorMapName.startsWith('reverseColmap(')) {
		colorMapName = colorMapName.split('(')[1].split(')')[0];
		reverseColorMap = true
	} else if (colorMapName.endsWith('_r')) {
		colorMapName = colorMapName.split('_r')[0];
		reverseColorMap = true
	}

	const colorMap = reverseColorMap ? reverseColorscale(colormaps[colorMapName]) : colormaps[colorMapName];
	return colorMap;
}